module.exports = __webpack_public_path__ + "img/gh-36204-4-12.prt.3468be55.jpg";